<template>
	<v-container fill-height fluid class="pa-0">
		<Cla />
		<Excluir />
		<Novo />
		<v-row class="ma-0">
			<v-col cols="12" class="pa-0">
				<v-card tile :height="this.$store.getters.alturaContent" cols="12" :loading="loading">
					<v-card-title>
						<v-toolbar flat dense>
						<v-spacer></v-spacer>
							<v-btn color="primary" small @click="criarNovoCla()">Novo</v-btn>
						</v-toolbar>
					</v-card-title>
					<v-card-text>
						<v-data-table :page.sync="pagina" hide-default-footer :height="this.$store.getters.alturaContent - 170"
						locale="pt-BR" dense fixed-header class="table-item" :items="clas" :headers="fields" :items-per-page="itensPorPagina">
							<template v-slot:item.action="{ item }">
								<v-btn icon class="mx-1" color="primary" @click="editar(item)">
									<v-icon>mdi-lead-pencil</v-icon>
								</v-btn>
								<v-btn icon color="primary"  @click="excluir(item)">
									<v-icon>mdi-delete</v-icon>
								</v-btn>
							</template>
						</v-data-table>
						<v-row>
                            <v-col cols=12>
                                <v-pagination :length="totalPaginas" total-visible="7" v-model="pagina">
                                </v-pagination>
                            </v-col>
                        </v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import { baseApiUrl, showError } from "@/config/global"
	import axios from 'axios'
	import Cla from '@/components/cadastros/clas/Cla'
	import Excluir from '@/components/cadastros/clas/ExcluirCla'
	import Novo from '@/components/cadastros/clas/NovoCla'
	import metodos from '@/mixins/metodos.js'
	import Br from '@/config/barramento.js'

	export default{
		mixins:[metodos],
		components:{Cla, Excluir, Novo},
		data(){
			return {
				loading: false,
				pagina: 1,
                totalPaginas: 1,
                itensPorPagina: 8,
				clas: [],
				fields: [
					{value: 'id', text: 'Código', sortable: true},
					{value: 'nome_cla', text: 'Nome', sortable: true},
					{value: 'nome_mestre', text: "Mestre", sortable: true},
					{text: 'Ações', value: 'action', align: 'center', divider: true}
				],

			}
		},
		methods:{
			buscaClas(){
				this.loading = true
				const url = `${baseApiUrl}/Cadastros/clas/read.php`

				axios.get(url)
						.then(res => {
							if(res.data.codigo == "01"){
								this.clas = res.data.dados.map(cl => {
									return {
										...cl,
										inicioObj: this.converterData(cl.data_inicio),
									}
								})
							}
							this.totalPaginas = Math.ceil(this.clas.length / this.itensPorPagina)
							this.loading = false
						})
						.catch({showError})
			},

			close(){
				this.showModal = false
			},
			editar(cla){
				Br.setEditarCla(cla)
			},
			criarNovoCla(){
				Br.setNovoCla()
			},
			
			excluir(cla){
				Br.setExcluirCla(cla)
			}

		},

		created(){
			this.buscaClas()

			Br.onClaExcluido(cla => {
					let idx = this.clas.findIndex((v) => {
                               return v.id == cla.id
                            })

							this.clas.splice(idx, 1)
				})

			Br.onClaCadastrado(cla => {
				this.clas.push(cla)
			})

			Br.onClaAtualizado(cla => {
				let idx = this.clas.findIndex((v) => {
					return v.id == cla.id
				})

				this.clas[idx] = cla
			})
		}
	}
</script>

<style scoped>

</style>